module.exports = __webpack_public_path__ + "media/svg-new/icon-refresh-c13f227d.svg";